export type EmptyObj = Record<PropertyKey, never>;
export function isEmptyObject(object: Record<string, any>): object is EmptyObj {
  return Object.keys(object).length === 0;
}
